import React from "react";
import Button from "../shared/Button/Button";

interface CustomImageProps {
  src: string;
  alt: string;
  customClassName?: string;
}

type HeaderButtonVariant = "default" | "login" | "signup";

interface HeaderButtonComponentProps {
  buttonText?: any;
  children?: JSX.Element;
  leftIcon?: CustomImageProps;
  rightIcon?: CustomImageProps;
  onClick: () => void;
  customCSS?: string;
  /** @deprecated Use buttonVariant="login" */
  isRedButton?: boolean;
  buttonVariant?: HeaderButtonVariant;
  customButtonHeight?: string;
  customButtonRadius?: string;
  loading?: boolean;
}

const HeaderButtonComponent: React.FC<HeaderButtonComponentProps> = ({
  buttonText = "button",
  children,
  leftIcon,
  rightIcon,
  onClick,
  customCSS,
  isRedButton = false,
  buttonVariant,
  customButtonHeight,
  customButtonRadius,
  loading,
}) => {
  const variant: HeaderButtonVariant =
    buttonVariant ?? (isRedButton ? "login" : "default");

  const variantBgClass = {
    default: "bg-blue4 active:bg-blue5",
    login: "bg-custom-red-gradient",
    signup: "bg-custom-green-gradient",
  }[variant];

  const isHeaderAction = variant === "login" || variant === "signup";

  return (
    <Button
      className={`flex shrink-0 items-center justify-center gap-1 whitespace-nowrap p-[4px_8px] text-[10px] font-[500] text-white
        ${buttonText === "Demo" || buttonText === "Demo Login" ? "bg-custom-red-gradient" : variantBgClass}
        ${isHeaderAction ? "min-w-[60px]" : ""}
        ${customCSS} ${customButtonHeight || "h-[28px] md:h-[28px]"} ${
        customButtonRadius || "rounded-[5px]"
      }`}
      onClick={onClick}
      loading={loading}
    >
      {leftIcon && (
        <img
          src={leftIcon.src}
          alt={leftIcon.alt}
          className={leftIcon.customClassName || "h-2.5 w-2.5"}
        />
      )}
      {children ? (
        children
      ) : (
        <span className="whitespace-nowrap text-xs font-bold text-white md:text-[13px]">
          {buttonText}
        </span>
      )}
      {rightIcon && (
        <img
          src={rightIcon.src}
          alt={rightIcon.alt}
          className={rightIcon.customClassName || "h-2.7 w-2.7 "}
        />
      )}
    </Button>
  );
};

export default HeaderButtonComponent;
